import Swiper from 'swiper/bundle';


export default class Caroussel{
    constructor(element){
        this.element = element;

        this.options = {
            slidesPerView: 'auto',
            speed: 1500,

            // Pagination bullets
            pagination: {
                el: this.element.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        }

        this.init();

    }

    setOptions(){
        if('autoplay' in this.element.dataset){
            this.options.autoplay = {
                delay: 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            }
        }

        if('loop' in this.element.dataset){
            this.options.loop = true;
        }
    }

    init(){
        this.setOptions();
        new Swiper(this.element, this.options);
    }

}